import { FC } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Box, Typography } from '@mui/material';

type Props = {
  orderTitle: string;
  value: number;
};

const OrderFormHeader: FC<Props> = ({ value, orderTitle }) => {
  return (
    <Box>
      <Typography fontSize={14} color={'#415965'}>
        <FormattedMessage id={orderTitle} />
      </Typography>
      <FormattedNumber value={value} unit={'kilogram'} style="unit" minimumFractionDigits={0} maximumFractionDigits={0} />
    </Box>
  );
};

export default OrderFormHeader;
